<template>
  <v-row class="py-16 fill-height" no-gutters>
    <v-col class="d-flex justify-end align-center">
        <v-avatar class="elevation-2" color="white" size="80">
        <img :src="require(`@/assets/appAsset-brand--piriod-icon.svg`)" alt="piriod" style="width:30px;">
        </v-avatar>
    </v-col>
    <v-col cols="5" class="d-flex justify-center align-center">
        <v-progress-linear buffer-value="0" color="green" reverse stream value="0" height="24">
        <template v-slot:default>
            <v-chip class="d-block" color="green accent-4" dark small>Integración activa</v-chip>
        </template>
        </v-progress-linear>
    </v-col>
    <v-col class="d-flex justify-start align-center">
        <v-avatar class="elevation-2" color="white" size="80">
        <img :src="require(`@/assets/appAsset-brand--${integration}.svg`)" :alt="integration" style="width:70px">
        </v-avatar>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    integration: {
      type: String,
      required: true
    }
  }
}
</script>